import { Box, Callout, Card, Flex, Theme } from '@radix-ui/themes';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { ERROR_COLOR, INFO_COLOR, SUCCESS_COLOR } from '~/lib/theme/themes';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const Wrapper = styled(Card)`
  animation: ${fadeIn} 0.1s linear;
  &:hover {
    cursor: pointer;
  }
`;

const TYPE_TO_COLOR_MAPPING = {
  error: ERROR_COLOR,
  success: SUCCESS_COLOR,
  normal: INFO_COLOR,
  info: INFO_COLOR,
};

function Notification({ forcedTheme, children, icon, onClick, type }) {
  return (
    <Theme appearance={forcedTheme}>
      <Wrapper
        p='0'
        mb='-6'
        mx='6'
        asChild
      >
        <Box>
          <Flex
            display='flex'
            asChild
          >
            <Callout.Root
              size='1'
              color={TYPE_TO_COLOR_MAPPING[type ?? 'normal']}
              role={type === 'error' ? 'alert' : null}
              onClick={onClick}
            >
              {icon && <Callout.Icon>{icon}</Callout.Icon>}
              <Box
                width='100%'
                asChild
              >
                <Callout.Text as='div'>{children}</Callout.Text>
              </Box>
            </Callout.Root>
          </Flex>
        </Box>
      </Wrapper>
    </Theme>
  );
}

Notification.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.node,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['error', 'success', 'normal']),
  forcedTheme: PropTypes.string,
};

export default Notification;
